import { render, staticRenderFns } from "./PaymentRequisitionDetailActivityCard.vue?vue&type=template&id=9af49614&"
import script from "./PaymentRequisitionDetailActivityCard.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionDetailActivityCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports